import { useQuery } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';

export function useDeviceLogs(deviceId, params = {}) {
  return useQuery({
    queryKey: ['settings', 'device-logs', deviceId, params],
    queryFn: async () => {
      const { data } = await api.get(`/devices/${deviceId}/logs`, { params });
      return data;
    },
    enabled: !!deviceId,
    staleTime: 15_000
  });
}
